import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/contextParameters'

export const setContextParameters = R.assoc('contextParameters', R.__, { type: actionTypes.SET_CONTEXT_PARAMETERS })
export const clearContextParameters = () => ({ type: actionTypes.CLEAR_CONTEXT_PARAMETERS })
